import React from 'react';

const PageTitle = ({ children, ...props }) => {
    return (
        <h1 {...props} css={styles}>
            {children}
        </h1>
    );
}

const styles = {
    fontWeight: 400,
    fontSize: "42px",
    "@media (min-width: 768px)": {
        fontSize: "54px",
        lineHeight: 1.25
    }
};

export default PageTitle
